import React from 'react'
import { Link } from 'react-router-dom'
import { useMediaQuery } from 'react-responsive'

import FeatureList from '../Components/FeatureList'

const TopSection = ({ activeType, currentImages, is_auth = false, t }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 991px)' })

    return (
        <div className="mft-top-section">
            <div className="mft-top-section__description">
                <div className="mft-top-section__description-title">
                    <span>{t(activeType.texts.titleTop)}</span>
                    <span>{t(activeType.texts.titleBottom)}</span>
                </div>
                {isMobile ? (
                    <div className="mft-top-section__image-container">
                        <img src={currentImages.top} alt="" />
                    </div>
                ) : null}
                <div className="mft-top-section__description-text">{t(activeType.texts.description)}</div>
                <div className="mft-top-section__description-buttons">
                    <Link
                        to={`/template-gallery/${activeType.customId}`}
                        className="button-style"
                        data-variant="secondary"
                    >
                        {t(`view templates`)}
                    </Link>
                    <Link
                        to={`${is_auth ? `/template-gallery/${activeType.customId}` : '/auth?action=registration'}`}
                        className="button-style"
                        data-variant="primary"
                    >
                        {t(`create for free`)}
                    </Link>
                </div>
                <div className="mft-top-section__description-feature-list">
                    <FeatureList list={activeType.texts.featureList} t={t} />
                </div>
            </div>
            {!isMobile ? (
                <div className="mft-top-section__image-container">
                    <img src={currentImages.top} alt="" />
                </div>
            ) : null}
        </div>
    )
}

export default TopSection
